/**
 * https://usehooks-ts.com/react-hook/use-interval
 * We use this hook as a replacement for setInterval
 * The main difference between the setInterval you know and this
 * useInterval hook is that its arguments are "dynamic".
 * https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 */
import { useEffect, useRef } from 'react';
export const useInterval = (callback, delay) => {
  const savedCallback = useRef(callback); // Remember the latest callback if it changes.

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]); // Set up the interval.

  useEffect(() => {
    // Don't schedule if no delay is specified.
    // Note: 0 is a valid value for delay.
    if (!delay && delay !== 0) {
      return;
    }

    const id = setInterval(() => savedCallback.current(), delay); // eslint-disable-next-line consistent-return

    return () => clearInterval(id);
  }, [delay]);
};
export default useInterval;